import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import { assignedOptionsData } from './assignData';
import NavigationWrapper from './NavigationWrapper';

const initialState = {
  currentStage: 'pre-section',
  selectedDocuments: [],
  selectedAirRefundDocuments: [],
  selectedCourtDocuments: []
};

class TaskCreator extends Component {
  componentDidMount() {
    this.props.clearTaskValues();
  }

  get taskValues() {
    const { claim, taskValues, taskType, stages, sections } = this.props;
    const options = assignedOptionsData(claim, taskType);
    const optionsData = {
      options,
      stages,
      sections,
      ...initialState,
      ...taskValues
    };
    return optionsData;
  }

  handleOptionsChange = (name, value) => {
    const { setTaskValues } = this.props;
    const { options } = this.taskValues;
    setTaskValues({
      options: { ...options, [name]: value }
    });
  };

  setErrorMessage = text =>
    this.props.showMessage({ text, props: { negative: true }, duration: 2000 });

  handleSelectChange = (e, { name, value }) =>
    this.handleOptionsChange(name, value);

  handleMultiSelectChange = (name, id) => {
    const { options } = this.taskValues;
    this.handleOptionsChange(name, _.xor(options[name], [id]));
  };

  handleDateChange = (date, id) =>
    this.handleOptionsChange(id, moment(date).format('YYYY-MM-DDTHH:mm:ss'));

  handleTemplateInputChange = (value, name) => {
    const { setTaskValues } = this.props;
    const { fullPaxFieldsData } = this.taskValues;
    const newFullPaxFieldsData = [...fullPaxFieldsData];
    const fieldIndex = _.findIndex(newFullPaxFieldsData, ['id', name]);
    newFullPaxFieldsData[fieldIndex] = {
      ...newFullPaxFieldsData[fieldIndex],
      value
    };
    setTaskValues({ fullPaxFieldsData: newFullPaxFieldsData });
  };

  handleSubmit = () => {
    const {
      acceptTask,
      clearTaskValues,
      onTaskComplete,
      task: { claimId }
    } = this.props;
    const onSuccess = () => {
      clearTaskValues();
      onTaskComplete();
    };
    const onError = () =>
      this.setErrorMessage('Error. Formal notice was not submitted');
    acceptTask({ claimId }, { onSuccess, onError });
  };

  render = () => {
    const { claim } = this.props;
    if (!claim) return null;
    return (
      <NavigationWrapper
        {...this.props}
        taskValues={this.taskValues}
        handleOptionsChange={this.handleOptionsChange}
        setErrorMessage={this.setErrorMessage}
        onTemplateInputChange={this.handleTemplateInputChange}
        onSelectChange={this.handleSelectChange}
        onMultiSelectChange={this.handleMultiSelectChange}
        onDateChange={this.handleDateChange}
        handleSubmit={this.handleSubmit}
      />
    );
  };
}

export default TaskCreator;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/index.js